import { route, type Route } from '$lib/state/route.svelte';

/** Mirror carried scope for a real href, including modifier-click/new tabs. */
export function scopedLinkHref(target: Route, current: Route): string {
  const filters = target.filters ?? (target.tab===current.tab && ['people','activities','issues'].includes(target.tab) ? current.filters : undefined);
  const params = new URLSearchParams(filters);
  const vertical = target.vertical ?? current.vertical;
  if (vertical) params.set('vertical',vertical);
  let path = `#/${target.tab}`;
  if ('id' in target && target.id) path+=`/${target.id}`;
  if (target.tab==='admin' && target.sub) path+=`/${target.sub}`;
  if (target.tab==='feedback') path+=`/${encodeURIComponent(target.token)}`;
  return params.size ? `${path}?${params}` : path;
}

/** Keep the anchor/CSS semantics, but ordinary clicks use guarded route.push. */
export function internalLink(node: HTMLAnchorElement, initialTarget: Route) {
  let target=initialTarget;
  const refresh=()=>node.setAttribute('href',scopedLinkHref(target,route.current));
  const click=(event:MouseEvent)=>{
    refresh();
    if(event.defaultPrevented || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
    event.preventDefault();route.push(target);
  };
  refresh();
  node.addEventListener('click',click);
  node.addEventListener('pointerdown',refresh);
  node.addEventListener('contextmenu',refresh);
  node.addEventListener('focus',refresh);
  return {
    update(next:Route){target=next;refresh();},
    destroy(){node.removeEventListener('click',click);node.removeEventListener('pointerdown',refresh);node.removeEventListener('contextmenu',refresh);node.removeEventListener('focus',refresh);}
  };
}
